import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectsandUsers, get_dispute_data, dispute_create, dispute_cancel, reply_to_dispaute, getDispute, offer_Dispute, acceptRejectOffer, getProjectDisputes, payArbitition, createProjectDispute} from '../../Apis';


export const GetProjectsAndUsers = createAsyncThunk('GetProjectsAndUsers', async (token, { rejectWithValue }) => {
    try {
        const response = await getProjectsandUsers(token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetDisputedMilestone = createAsyncThunk('GetDisputedMilestone', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_dispute_data(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetDispute = createAsyncThunk('GetDispute', async ({ id, token }, { rejectWithValue }) => {
    try {
        const response = await getDispute(id, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const CreateDispute = createAsyncThunk('CreateDispute', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await dispute_create(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const CreateProjectDispute = createAsyncThunk('CreateProjectDispute', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await createProjectDispute(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CancelDispute = createAsyncThunk('CancelDispute', async ({ id, token }, { rejectWithValue }) => {
    try {
        const response = await dispute_cancel(id, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const SendDisputeReply = createAsyncThunk('SendDisputeReply', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await reply_to_dispaute(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const OfferDispute = createAsyncThunk('OfferDispute', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await offer_Dispute(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const AcceptRejectOffer = createAsyncThunk('AcceptRejectOffer', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await acceptRejectOffer(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetProjectDisputes = createAsyncThunk('GetProjectDisputes', async ({ type, token, page, pageSize, search }, { rejectWithValue }) => {
    try {
        const response = await getProjectDisputes(type, token, page, pageSize, search);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const MarkAsPaid = createAsyncThunk('MarkAsPaid', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await payArbitition(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const disputeSlice = createSlice({
    name: 'dispute',
    initialState: {
        error: null,
        success: false,
        data: {},
        data2: {},
        disputes: [],
        projects: []
    },
    reducers: {
        clearChatStatus: state => {
            state.success = false;
            state.error = null;
        },

    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(GetProjectsAndUsers.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetProjectsAndUsers.fulfilled, (state, action) => {
                state.projects = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetProjectsAndUsers.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

            .addCase(GetDisputedMilestone.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetDisputedMilestone.fulfilled, (state, action) => {
                state.data = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetDisputedMilestone.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetProjectDisputes.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetProjectDisputes.fulfilled, (state, action) => {
                state.disputes = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetProjectDisputes.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetDispute.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetDispute.fulfilled, (state, action) => {
                state.data2 = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetDispute.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(CreateDispute.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CreateDispute.fulfilled, (state, action) => {
                state.error = null;
                state.success = action.payload;
            })
            .addCase(CreateDispute.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(CancelDispute.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CancelDispute.fulfilled, (state, action) => {
                state.error = null;
                state.success = action.payload;
            })
            .addCase(CancelDispute.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearChatStatus } = disputeSlice.actions;
export default disputeSlice.reducer;

